import { DateTime } from "luxon";

// Alert `date` fields are DateTimeFields, so a single-day filter is
// timezone-fragile: query a ±1-day server window and match the exact day
// client-side in UTC. Shared by the reco banner, model info, calendar heat-map
// and the alert hooks so the convention stays identical everywhere.
export interface DayWindow {
  day: DateTime;
  // Server filter bounds (ISO day, yyyy-MM-dd) — `date__gte` / `date__lt`.
  gte?: string;
  lt?: string;
}

export const dayWindow = (date?: string): DayWindow | null => {
  const day = date ? DateTime.fromISO(date, { zone: "utc" }) : null;
  if (!day || !day.isValid) return null;
  return {
    day,
    gte: day.minus({ days: 1 }).toISODate() ?? undefined,
    lt: day.plus({ days: 2 }).toISODate() ?? undefined,
  };
};

// Day (yyyy-MM-dd) of a serialized alert/model datetime, taken from the string
// as-is. Never convert these to UTC first: they are midnight datetimes, so any
// timezone offset in the payload shifts them to the previous day. Same
// convention as the legacy Calendar (`alert.date.split("T")[0]`).
export const alertDay = (value: string): string => value.split("T")[0] ?? value;

// True when an alert `value` (ISO datetime string) falls on `day`.
export const isSameAlertDay = (value: string, day: DateTime): boolean =>
  alertDay(value) === day.toISODate();
